<template>
<div>
  <v-text-field data-corporation="name"
      v-model="corporation.name" 
      label="Corporation Name" 
      required>
  </v-text-field>
  <v-text-field data-corporation="origin"
      v-model="corporation.origin" 
      label="Country of Origin" 
      required>
  </v-text-field>
  <v-text-field data-corporation="signer"
      v-model="corporation.signer" 
      label="Person signing the contracts" 
      required>
  </v-text-field>
    <v-text-field data-corporation="title"
      v-model="corporation.title" 
      label="Signers title" 
      required>
  </v-text-field>
</div>
</template>

<script>
export default {
  data: () => ({}),
  props: ["corporation"],
  computed: {},
  methods: {}
};
</script>

<style>
</style>
